import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMall"><Path d="M12 11.5V19.5" stroke="currentColor"/><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor"/><Path d="M7.5 19.5V11.5H16.5V19.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconMall;
